const LegalRisk = {
  riskLevels: [
    { value: 1, label: 'A', color: '#4CAF50', description: 'Very Low Risk' },
    { value: 2, label: 'B', color: '#8BC34A', description: 'Low Risk' },
    { value: 3, label: 'C', color: '#FFEB3B', description: 'Moderate Risk' },
    { value: 4, label: 'D', color: '#FFC107', description: 'High Risk' },
    { value: 5, label: 'E', color: '#FF5722', description: 'Very High Risk' }
  ],

  riskFactors: [
    {
      factor: 'contractEnforceability',
      label: 'Contract Enforceability',
      criteria: [
        { value: 1, label: 'A', color: '#4CAF50', rationale: 'Contracts are easily enforceable with minimal legal hurdles', description: 'Very Low Risk' },
        { value: 2, label: 'B', color: '#8BC34A', rationale: 'Contracts are generally enforceable with some legal considerations', description: 'Low Risk' },
        { value: 3, label: 'C', color: '#FFEB3B', rationale: 'Contracts are enforceable but with moderate legal challenges', description: 'Moderate Risk' },
        { value: 4, label: 'D', color: '#FFC107', rationale: 'Contracts face significant legal challenges and enforceability issues', description: 'High Risk' },
        { value: 5, label: 'E', color: '#FF5722', rationale: 'Contracts are very difficult to enforce with numerous legal obstacles', description: 'Very High Risk' }
      ]
    },
    {
      factor: 'jurisdiction',
      label: 'Jurisdiction',
      criteria: [
        { value: 1, label: 'A', color: '#4CAF50', rationale: 'Operating in jurisdictions with strong legal frameworks and protections', description: 'Very Low Risk' },
        { value: 2, label: 'B', color: '#8BC34A', rationale: 'Operating in jurisdictions with generally reliable legal systems', description: 'Low Risk' },
        { value: 3, label: 'C', color: '#FFEB3B', rationale: 'Operating in jurisdictions with moderate reliability of legal systems', description: 'Moderate Risk' },
        { value: 4, label: 'D', color: '#FFC107', rationale: 'Operating in jurisdictions with significant legal uncertainties', description: 'High Risk' },
        { value: 5, label: 'E', color: '#FF5722', rationale: 'Operating in jurisdictions with highly unpredictable or weak legal systems', description: 'Very High Risk' }
      ]
    },
    {
      factor: 'regulatoryCompliance',
      label: 'Regulatory Compliance',
      criteria: [
        { value: 1, label: 'A', color: '#4CAF50', rationale: 'Fully compliant with all relevant regulations with no issues', description: 'Very Low Risk' },
        { value: 2, label: 'B', color: '#8BC34A', rationale: 'Mostly compliant with minor regulatory issues', description: 'Low Risk' },
        { value: 3, label: 'C', color: '#FFEB3B', rationale: 'Moderately compliant with some regulatory issues', description: 'Moderate Risk' },
        { value: 4, label: 'D', color: '#FFC107', rationale: 'Significant regulatory compliance issues', description: 'High Risk' },
        { value: 5, label: 'E', color: '#FF5722', rationale: 'Non-compliant with major regulatory breaches', description: 'Very High Risk' }
      ]
    },
    {
      factor: 'disputeResolution',
      label: 'Dispute Resolution',
      criteria: [
        { value: 1, label: 'A', color: '#4CAF50', rationale: 'Effective dispute resolution mechanisms with quick resolutions', description: 'Very Low Risk' },
        { value: 2, label: 'B', color: '#8BC34A', rationale: 'Generally effective dispute resolution with occasional delays', description: 'Low Risk' },
        { value: 3, label: 'C', color: '#FFEB3B', rationale: 'Moderate effectiveness in dispute resolution with some delays', description: 'Moderate Risk' },
        { value: 4, label: 'D', color: '#FFC107', rationale: 'Ineffective dispute resolution with significant delays', description: 'High Risk' },
        { value: 5, label: 'E', color: '#FF5722', rationale: 'Highly ineffective dispute resolution, very lengthy and uncertain', description: 'Very High Risk' }
      ]
    },
    {
      factor: 'legalCosts',
      label: 'Legal Costs',
      criteria: [
        { value: 1, label: 'A', color: '#4CAF50', rationale: 'Low legal costs with affordable legal services', description: 'Very Low Risk' },
        { value: 2, label: 'B', color: '#8BC34A', rationale: 'Moderate legal costs, generally manageable', description: 'Low Risk' },
        { value: 3, label: 'C', color: '#FFEB3B', rationale: 'Average legal costs, can be significant', description: 'Moderate Risk' },
        { value: 4, label: 'D', color: '#FFC107', rationale: 'High legal costs, challenging to manage', description: 'High Risk' },
        { value: 5, label: 'E', color: '#FF5722', rationale: 'Very high legal costs, potentially prohibitive', description: 'Very High Risk' }
      ]
    },
    {
      factor: 'intellectualPropertyProtection',
      label: 'Intellectual Property Protection',
      criteria: [
        { value: 1, label: 'A', color: '#4CAF50', rationale: 'Strong intellectual property protection with robust enforcement', description: 'Very Low Risk' },
        { value: 2, label: 'B', color: '#8BC34A', rationale: 'Good intellectual property protection with effective enforcement', description: 'Low Risk' },
        { value: 3, label: 'C', color: '#FFEB3B', rationale: 'Moderate intellectual property protection with some enforcement', description: 'Moderate Risk' },
        { value: 4, label: 'D', color: '#FFC107', rationale: 'Weak intellectual property protection with limited enforcement', description: 'High Risk' },
        { value: 5, label: 'E', color: '#FF5722', rationale: 'Very weak intellectual property protection with minimal enforcement', description: 'Very High Risk' }
      ]
    },
    {
      factor: 'dataPrivacyLaws',
      label: 'Data Privacy Laws',
      criteria: [
        { value: 1, label: 'A', color: '#4CAF50', rationale: 'Strict data privacy laws with full compliance and protection', description: 'Very Low Risk' },
        { value: 2, label: 'B', color: '#8BC34A', rationale: 'Good data privacy laws with general compliance', description: 'Low Risk' },
        { value: 3, label: 'C', color: '#FFEB3B', rationale: 'Moderate data privacy laws with some compliance issues', description: 'Moderate Risk' },
        { value: 4, label: 'D', color: '#FFC107', rationale: 'Weak data privacy laws with significant compliance issues', description: 'High Risk' },
        { value: 5, label: 'E', color: '#FF5722', rationale: 'Very weak data privacy laws with poor compliance', description: 'Very High Risk' }
      ]
    },
    {
      factor: 'antiMoneyLaundering',
      label: 'Anti-Money Laundering (AML)',
      criteria: [
        { value: 1, label: 'A', color: '#4CAF50', rationale: 'Strict AML regulations with full compliance and no issues', description: 'Very Low Risk' },
        { value: 2, label: 'B', color: '#8BC34A', rationale: 'Good AML regulations with general compliance', description: 'Low Risk' },
        { value: 3, label: 'C', color: '#FFEB3B', rationale: 'Moderate AML regulations with some compliance issues', description: 'Moderate Risk' },
        { value: 4, label: 'D', color: '#FFC107', rationale: 'Weak AML regulations with significant compliance issues', description: 'High Risk' },
        { value: 5, label: 'E', color: '#FF5722', rationale: 'Very weak AML regulations with poor compliance', description: 'Very High Risk' }
      ]
    },
    {
      factor: 'legalTransparency',
      label: 'Legal Transparency',
      criteria: [
        { value: 1, label: 'A', color: '#4CAF50', rationale: 'Full legal transparency with clear and accessible legal information', description: 'Very Low Risk' },
        { value: 2, label: 'B', color: '#8BC34A', rationale: 'Good legal transparency with generally accessible legal information', description: 'Low Risk' },
        { value: 3, label: 'C', color: '#FFEB3B', rationale: 'Moderate legal transparency with some legal information accessible', description: 'Moderate Risk' },
        { value: 4, label: 'D', color: '#FFC107', rationale: 'Limited legal transparency with difficult to access legal information', description: 'High Risk' },
        { value: 5, label: 'E', color: '#FF5722', rationale: 'Very poor legal transparency with minimal accessible legal information', description: 'Very High Risk' }
      ]
    },
    {
      factor: 'poSalesContractCheck',
      label: 'PO/Sales Contract Check',
      criteria: [
        { value: 1, label: 'A', color: '#4CAF50', rationale: 'Complete and accurate identification of supplier and buyer', description: 'Very Low Risk' },
        { value: 2, label: 'B', color: '#8BC34A', rationale: 'Clear and detailed description of products/services with accurate quantity and pricing', description: 'Low Risk' },
        { value: 3, label: 'C', color: '#FFEB3B', rationale: 'Detailed payment terms suitable for factoring (due dates, methods, conditions)', description: 'Moderate Risk' },
        { value: 4, label: 'D', color: '#FFC107', rationale: 'Presence of a non-assignment clause that may affect factoring', description: 'High Risk' },
        { value: 5, label: 'E', color: '#FF5722', rationale: 'Contractual conditions or obligations that could impact factoring arrangements', description: 'Very High Risk' }
      ]
    }
  ],

  calculateOverallRisk: (scores) => {
    const totalScore = Object.values(scores).reduce((sum, score) => sum + score, 0);
    const averageScore = totalScore / Object.keys(scores).length;
    return Math.round(averageScore);
  },

  getRiskLevel: (score) => {
    return LegalRisk.riskLevels.find(level => level.value === score);
  },

  getRationale: (factor, score) => {
    const factorData = LegalRisk.riskFactors.find(f => f.factor === factor);
    if (!factorData) return 'No rationale provided';
    const criteria = factorData.criteria.find(c => c.value === score);
    return criteria ? criteria.rationale : 'No rationale provided';
  },

  getAssessment: (score) => {
    const riskLevel = LegalRisk.getRiskLevel(score);
    return riskLevel ? riskLevel.description : 'No assessment available';
  },

  getLabel: (score) => {
    const riskLevel = LegalRisk.getRiskLevel(score);
    return riskLevel ? riskLevel.label : 'N/A';
  },

  getColor: (score) => {
    const riskLevel = LegalRisk.getRiskLevel(score);
    return riskLevel ? riskLevel.color : '#000';
  },

  evaluateBuyer: (buyerScores) => {
    const overallScore = LegalRisk.calculateOverallRisk(buyerScores);
    const riskLevel = LegalRisk.getRiskLevel(overallScore);
    return {
      scores: buyerScores,
      overallScore,
      riskLevel
    };
  }
};

export default LegalRisk;